module.exports = __webpack_public_path__ + "static/img/bg2@2x.c082f40.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/birthday/bg2@2x.png
// module id = Miqq
// module chunks = 1